import React from 'react';
import { ValidationProps } from 'ui';
import { ResizeWrapper } from 'app/components/resize-wrapper';
import { TextConfigurationTranslation } from '../../../constants';
import { smResolution } from '../../constants';
import { ListTileColumn } from '../../common/list-tile-column';
import { ModifiedCodeDescription, CodeDescriptionSearchData, CodeDescriptionMetadata } from '../types-store';
import { CodeListHolder, CodeListItem } from './types';
import { CodeDescriptionItems } from './code-description-items';
import { CodeDescriptionTable } from './code-description-table';
import { CodeDescriptionRow } from './code-description-row';
import { CodeDescriptionTile } from './code-description-tile';

interface TextListResultsProps {
  metadata: CodeDescriptionMetadata;
  textsList: CodeDescriptionSearchData[];
  modifiedTexts: ModifiedCodeDescription[];
  modifyText: (modifiedText: ModifiedCodeDescription) => void;
  validation: { [key: string]: ValidationProps };
  translation: TextConfigurationTranslation;
}

const CodeDescriptionResultsComponent: React.FC<TextListResultsProps> = (props) => {

  const isMobile = (props as TextListResultsProps & { width: number }).width <= smResolution;

  const HolderComponent: CodeListHolder = isMobile ? ListTileColumn : CodeDescriptionTable;
  const ItemComponent: CodeListItem = isMobile ? CodeDescriptionTile : CodeDescriptionRow;

  const { metadata, textsList, modifiedTexts, modifyText, validation, translation } = props;

  return <CodeDescriptionItems
    HolderComponent={HolderComponent}
    ItemComponent={ItemComponent}
    metadata={metadata}
    textsList={textsList}
    modifiedTexts={modifiedTexts}
    modifyText={modifyText}
    validation={validation}
    translation={translation} />;
};

export const CodeDescriptionResults: React.FC<TextListResultsProps> = (props) => {
  return <ResizeWrapper>
    <CodeDescriptionResultsComponent {...props} />
  </ResizeWrapper>;
};
